module.exports = __webpack_public_path__ + "img/micro-component.4cbd1e59.png";